import type { UserItem, UserServerListItem } from '../types/users.types'

import { normalizeImage } from './image.adapters'

export const normalizeUsers = (data: UserServerListItem[]): UserItem[] => {
  return data.map((item) => ({
    id: item.id,
    username: item.username,
    email: item.email,
    displayName: item.display_name,
    clientId: item.client_id,
    locale: item.locale,
    ...(item.image && { image: normalizeImage(item.image) }),
  }))
}
